<template>
  <div>
    <v-toolbar
      dense
      color="primary"
      :dark="true"
      @click="onClickToggle"
    >
      <v-row
        align="center"
        justify="start"
      >
        <v-btn
          icon
          @click.stop="onClickToggle"
        >
          <v-icon
            large
            color="white"
          >
            {{ iconArrow }}
          </v-icon>
        </v-btn>
        <v-toolbar-title class="ml-2">
          {{ title }}
        </v-toolbar-title>
      </v-row>
    </v-toolbar>
    <v-card
      class="border pa-4 v-card-Analysis"
      style="overflow-x: auto;"
      :class="showChildren ? '' : 'hidden'"
      @scroll="handleScroll"
    >
      <slot />
    </v-card>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        openedChildren: {
            type: Boolean,
            default: false,
        },


    },
    data() {
        return {
            showChildren: false,
        };
    },
    computed: {
        iconArrow() {
            return this.showChildren ? 'mdi-menu-down' : 'mdi-menu-right';
        },
    },
    mounted() {
        this.openChildren();
    },
    methods: {
        onClickToggle() {
            this.showChildren = !this.showChildren;
        },
        openChildren() {
            if (this.openedChildren) this.showChildren = true;
        },
        handleScroll(evt) {
            // Scroll horizontal
            // distance en px qu'on a scrollé depuis la gauche
            const widthFirstColumn = 170;
            const marginLeft = 15;
            const decalageHorizontal = evt.target.scrollLeft - (evt.target.scrollLeft < widthFirstColumn ? 0 : marginLeft);
            const translate = `translateX(${decalageHorizontal}px)`;

            /*  1er tableau */
            const blocTitles1 = document.getElementsByClassName('firstTab');
            for (let i = 0; i < blocTitles1.length; i += 1) {
                blocTitles1[i].style.transform = translate;
                blocTitles1[i].style.webkitTransform = translate;
            }

            /* Titre intermédiaire  */
            const title = document.getElementsByClassName('analysis-label-lab');
            if (title.length) {
                title[0].style.transform = translate;
                title[0].style.webkitTransform = translate;
            }
            /*  2eme tableau */
            const blocTitles2 = document.getElementsByClassName('secondTab');
            for (let i = 0; i < blocTitles2.length; i += 1) {
                blocTitles2[i].style.transform = translate;

                blocTitles2[i].style.webkitTransform = translate;
                blocTitles2[i].style.webkitBoxShadow = '2px 0px 0px 0px #C4C4C4';
            }

            // Scroll vertical
            const blocHeader = document.getElementsByClassName('column-title');
            const headerHeight = 64;
            const marginTop = 20;
            const decalageVertical = evt.target.scrollTop - (evt.target.scrollTop < headerHeight ? 0 : marginTop);

            for (let i = 0; i < blocHeader.length; i += 1) {
                blocHeader[i].style.webkitTransform = `translateY(${decalageVertical}px)`;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
  .hidden {
    display: none;
  }
  .v-card-Analysis {
    overflow-y: scroll;
    height: calc(100vh - 200px);
  }
</style>
